import { makeStyles } from '@material-ui/core/styles';

export const useResumeCardStyles = makeStyles(
  theme => ({
    resumeItem: {
      listStyle: 'none',
      display: 'flex',
      alignItems: 'flex-start',
      padding: theme.spacing(2, 0),
      position: 'relative',
      transition: 'all 0.2s ease',
      '&:not(:last-child)': {
        borderBottom: `1px solid ${theme.palette.divider}`
      },
      '&:hover $actionsContainer': {
        opacity: 1,
        pointerEvents: 'auto'
      }
    },
    actionsContainer: {
      position: 'absolute',
      top: theme.spacing(0.5),
      right: theme.spacing(0.5),
      display: 'flex',
      alignItems: 'center',
      gap: theme.spacing(0.5),
      opacity: 0,
      pointerEvents: 'none',
      transition: 'opacity 0.2s ease',
      zIndex: 1
    },
    actionButton: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: theme.spacing(1.5),
      borderRadius: '50%',
      cursor: 'pointer',
      textDecoration: 'none',
      '&:hover': {
        backgroundColor: theme.palette.action.hover
      }
    },
    actionIcon: {
      fill: theme.palette.grey[600],
      width: 20,
      height: 20
    },
    disabledAction: {
      pointerEvents: 'none',
      cursor: 'default',
      '& $actionIcon': {
        fill: theme.palette.customColors.disabledIcon
      }
    },
    checkboxContainer: {
      flexShrink: 0,
      marginRight: theme.spacing(1),
      marginTop: theme.spacing(-1)
    },
    resumeContent: {
      flex: 1,
      minWidth: 0,
      '& > div:last-child': {
        marginBottom: 0
      }
    },
    resumeHeader: {
      display: 'flex',
      flexDirection: 'column',
      marginBottom: theme.spacing(1.5)
    },
    resumeInfoBox: {
      display: 'flex',
      alignItems: 'center',
      flex: 1
    },
    metadataRow: {
      display: 'inline-flex',
      alignItems: 'center',
      marginLeft: theme.spacing(0.5),
      gap: theme.spacing(1)
    },
    titleLine: {
      fontWeight: theme.typography.fontWeightMedium
    },
    keyFactsLine: {
      fontWeight: theme.typography.fontWeightMedium,
      color: theme.palette.text.primary
    },
    descriptionText: {
      whiteSpace: 'pre-wrap'
    },
    activityFooter: {
      display: 'flex',
      flexWrap: 'wrap',
      alignItems: 'center',
      gap: theme.spacing(2),
      marginTop: theme.spacing(0.5)
    },
    activityFooterItem: {
      display: 'flex',
      alignItems: 'center',
      gap: theme.spacing(0.5)
    },
    emailWarningChip: {
      paddingLeft: theme.spacing(0.5),
      '& .MuiChip-icon': {
        width: 14,
        height: 14,
        display: 'flex',
        alignSelf: 'center',
        marginLeft: theme.spacing(0.25),
        marginRight: 0
      }
    }
  }),
  { name: 'ResumeCard' }
);
